module.exports = __webpack_public_path__ + "static/media/sports.b527ba91.jpg";